<template>
    <div style="padding: 1vw">
        <div class="container-wrapper">
            <div class="page-title-container">
            <div class="page-title">
                    <h3 class="fw-bold" style="color: #000; font-size: 1.8rem; display: flex; justify-content: space-between;">
                    클라라 발송 대상 조회
                    <div style="display: flex; align-items: center;">
                        <a-button type="primary" @click="goToCertificateList">
                            목록으로 돌아가기
                        </a-button>
                    </div>
                    </h3>
                    <span class="pageDesc">
                    클라라 투명교정 정기 알림톡 발송 대상을 조회하고 알림톡 이력을 조회할 수 있습니다.
                    </span>
                </div>
            </div>
        </div>
        <div class="container-wrapper">
            <div class="clara-modal-container">
                <div class="clara-search-filter-container">
                    <div class="modal-datepicker-area">
                        <span class="label-text">날짜 선택</span>
                        <a-range-picker
                            class="modal-a-datepicker"
                            v-model:value="searchParams.dateRange"
                            format="YYYY-MM-DD"
                            @change="handleDateChange"
                        />
                    </div>
                    <div class="search-filter-checkbox">
                        <a-checkbox v-model:checked="searchParams.excludeTestCompany" @change="fetchData">
                            테스트 병원 제외
                        </a-checkbox>
                    </div>
                    <div class="search-filter-select">
                        <a-select class="search-select" v-model:value="rowsPerPage" @change="fetchData">
                            <a-select-option :value="10">10개씩 보기</a-select-option>
                            <a-select-option :value="20">20개씩 보기</a-select-option>
                            <a-select-option :value="50">50개씩 보기</a-select-option>
                      </a-select>
                    </div>
                </div>
                <a-table
                    :columns="columns"
                    :data-source="data"
                    @change="handleTableChange"
                    :pagination="false"
                >
                    <template #emptyText>
                        <div class="noResult">발송 대상이 없습니다.</div>
                    </template>
                </a-table>
                <pagination 
                    :page-info="paginationData"
                    page-name="CertificateList"
                    @change-page="paginationHandler"
                />
            </div>
        </div>
    </div>
    <ClaraDetailModal
        :showModal="modals.detailModal.show"
        :record="modals.detailModal.record"
        @closeModal="closeDetailModal"
    />
</template>
<script>
import { phoneNumberFormatter } from '@/utils/utils';
import dayjs from 'dayjs';
import { 
    WarrantyStatusEnum,
} from "@/enums/common.enums";
import ClaraDetailModal from './components/ClaraDetailModal.vue';
import Pagination from '@/views/components/Pagination.vue';
export default {
    name: 'ClaraManage',
    components: {
        ClaraDetailModal,
        Pagination,
    },
    data() {
        return {
            columns: [
                {
                    title: '병원명',
                    dataIndex: 'companyName',
                    key: 'companyName',
                    align: 'center',
                },
                {
                    title: '환자명',
                    dataIndex: 'customerName',
                    key: 'customerName',
                    align: 'center',
                },
                {
                    title: '연락처',
                    dataIndex: 'customerMobile',
                    key: 'customerMobile',
                    align: 'center',
                    customRender: ({ text }) => phoneNumberFormatter(text)
                },
                {
                    title: '시술 부위',
                    dataIndex: ['surgeryArea', 'value'],
                    key: 'surgeryArea',
                    align: 'center',
                },
                {
                    title: '시술일',
                    dataIndex: 'surgeryAt',
                    key: 'surgeryAt',
                    align: 'center',
                    customRender: ({ text }) => dayjs(text).format('YYYY-MM-DD')
                },
                {
                    title: '직전 발송일',
                    dataIndex: ['deliveryOptions', 'afterDeliveryInfo'],
                    key: 'lastDeliveryDate',
                    align: 'center',
                    customRender: ({ text, record }) => {
                        const afterDeliveryInfo = record.deliveryOptions?.afterDeliveryInfo;
                        if (!afterDeliveryInfo || !afterDeliveryInfo.length) return '-';
                        
                        // 모든 발송 날짜 정보 수집
                        let allDeliveryDates = [];
                        
                        afterDeliveryInfo.forEach(info => {
                            if (info.deliveryDates && info.deliveryDates.length) {
                                info.deliveryDates.forEach(dateInfo => {
                                    allDeliveryDates.push({
                                        date: dateInfo.date,
                                        status: dateInfo.status
                                    });
                                });
                            }
                        });
                        
                        if (allDeliveryDates.length === 0) return '-';
                        
                        // 날짜순으로 정렬
                        allDeliveryDates.sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));
                        
                        // 모든 날짜가 'book' 상태인지 확인
                        const allBook = allDeliveryDates.every(date => date.status === 'book');
                        if (allBook) {
                            return <span style={{ color: '#1890ff' }}>최초 알림톡</span>;
                        }
                        
                        // 'book' 상태인 날짜가 있는지 확인
                        const hasBookDate = allDeliveryDates.some(date => date.status === 'book');
                        
                        if (!hasBookDate) {
                            // 모두 발송된 경우 마지막 발송일 표시
                            const lastSentDate = allDeliveryDates
                                .filter(date => date.status === 'sent')
                                .sort((a, b) => dayjs(b.date).diff(dayjs(a.date)))[0];
                                
                            if (lastSentDate) {
                                return <span>{dayjs(lastSentDate.date).format('YYYY/MM/DD')}</span>;
                            }
                            return '-';
                        }
                        
                        // 다음 발송 예정일 찾기 (book 상태인 가장 빠른 날짜)
                        let nextDeliveryDate = null;
                        
                        for (let i = 0; i < allDeliveryDates.length; i++) {
                            if (allDeliveryDates[i].status === 'book') {
                                nextDeliveryDate = allDeliveryDates[i].date;
                                break;
                            }
                        }
                        
                        // 다음 발송 예정일 직전의 날짜 찾기
                        let lastDate = null;
                        let lastDateStatus = null;
                        
                        for (let i = 0; i < allDeliveryDates.length; i++) {
                            const currentDate = allDeliveryDates[i];
                            
                            // 현재 날짜가 다음 발송 예정일과 같거나 이후라면 루프 종료
                            if (dayjs(currentDate.date).isSame(dayjs(nextDeliveryDate)) || 
                                dayjs(currentDate.date).isAfter(dayjs(nextDeliveryDate))) {
                                break;
                            }
                            
                            // 상태 관계없이 마지막 날짜 저장
                            lastDate = currentDate.date;
                            lastDateStatus = currentDate.status;
                        }
                        
                        if (!lastDate) return '-'; // 직전 발송일이 없으면 '-' 반환
                        
                        // 과거 날짜이고 book 상태면 빨간색, sent 상태면 검은색
                        const isPast = dayjs(lastDate).isBefore(dayjs());
                        const isBook = lastDateStatus === 'book';
                        
                        if (isPast && isBook) {
                            return <span style={{ color: '#ff4d4f' }}>{dayjs(lastDate).format('YYYY/MM/DD')}</span>;
                        } else {
                            return <span>{dayjs(lastDate).format('YYYY/MM/DD')}</span>;
                        }
                    }
                },
                { 
                    key: 'nextDeliveryAt', 
                    title: '다음 발송 예정일', 
                    dataIndex: 'nextDeliveryAt', 
                    align: 'center',
                    sortDirections: ['descend', 'ascend', null],
                    showSorterTooltip: {
                        title: '다음 발송 예정일 기준으로 정렬'
                    },
                    sorter: true,
                    customRender: ({ text, record }) => {
                                if (record.deliveryOptions?.nextDeliveryAt) {
                                    return dayjs(record.deliveryOptions.nextDeliveryAt).format('YYYY/MM/DD');
                                }
                                return '-';
                            }
                },
                {
                    key: 'surgeryEndAt',
                    title: '시술 종료일',
                    dataIndex: 'surgeryEndAt',
                    align: 'center',
                    customRender: ({ text, record }) => {
                        if(record.issueStatus === WarrantyStatusEnum.DISPOSED || record.issueStatus === WarrantyStatusEnum.RETURNED) return '-';
                        if (!record.deliveryOptions?.surgeryEndAt) return '-';
                        
                        const surgeryEndAt = dayjs(record.deliveryOptions.surgeryEndAt);
                        const now = dayjs();

                        // 수술 종료일이 과거 시점이면 시술 종료된 것, 정상으로 표기
                        if(surgeryEndAt.isBefore(now)){
                            return surgeryEndAt.format('YYYY/MM/DD');
                        }

                        let isOverdue = false;
                        let lastDeliveryDate = null;

                        // afterDeliveryInfo 배열이 있는 경우 검사
                        if (record.deliveryOptions?.afterDeliveryInfo?.length > 0) {
                            // 모든 그룹의 deliveryDates를 확인
                            const hasBookedDates = record.deliveryOptions.afterDeliveryInfo.some(info => {
                                if (!info.deliveryDates?.length) return false;
                                return info.deliveryDates.some(date => date.status === 'book');
                            });

                            // 마지막 발송일 찾기
                            lastDeliveryDate = record.deliveryOptions.afterDeliveryInfo.reduce((lastDate, info) => {
                                if (!info.deliveryDates?.length) return lastDate;
                                
                                const groupLastDate = info.deliveryDates.reduce((latest, date) => {
                                    const currentDate = dayjs(date.date);
                                    return currentDate.isAfter(latest) ? currentDate : latest;
                                }, dayjs(0));

                                return groupLastDate.isAfter(lastDate) ? groupLastDate : lastDate;
                            }, dayjs(0));

                            // 마지막 발송일이 시술 종료일보다 과거이고, 예약된 발송이 없는 경우
                            isOverdue = lastDeliveryDate.isBefore(surgeryEndAt) && !hasBookedDates;
                        }

                        const dateText = surgeryEndAt.format('YYYY/MM/DD');
                        if (isOverdue && lastDeliveryDate) {
                            const tooltipText = (
                                <div>
                                    등록한 알림톡을 모두 발송했습니다.<br />
                                    추가 알림톡을 등록해주세요.
                                </div>
                            );
                            
                            return (
                                <a-tooltip title={tooltipText}>
                                    <span style={{ color: '#ff4d4f', cursor: 'help' }}>
                                        {dateText}
                                    </span>
                                </a-tooltip>
                            );
                        }

                        return <span>{dateText}</span>;
                    }
                },
                {
                    key: 'messageSentStatus',
                    title: '알림톡 발송 상태',
                    dataIndex: 'surgeryEndAt',
                    align: 'center',
                    width: '125px',
                    customRender: ({ text, record }) => {
                        if(record.issueStatus === WarrantyStatusEnum.DISPOSED || record.issueStatus === WarrantyStatusEnum.RETURNED) return '-';
                        if (!record.deliveryOptions?.surgeryEndAt) return '-';

                        // SPEC-CLARA-DELIVERY-STATUS-001 (P3): 서버 정합화 결과(claraStatus) 우선 사용.
                        // 실제 발송 이력 기준이므로 활성 발송 중인 환자의 거짓 '발송 실패'가 제거된다.
                        if (record.claraStatus) {
                            const statusMap = {
                                failed:  { cls: 'red',    label: '발송 실패', tip: '예약된 알림톡이 한 번도 발송되지 않아 발송 실패로 처리되었습니다.' },
                                stopped: { cls: 'red',    label: '발송 중단', tip: '정기 발송이 중단된 것으로 확인됩니다. 실제 발송 여부를 확인해 주세요.' },
                                waiting: { cls: 'orange', label: '발송 대기', tip: '오늘 발송 예정인 알림톡이 있습니다. 당일 중 발송될 예정입니다.' },
                                normal:  { cls: 'green',  label: '정상 발송', tip: '' },
                                unset:   { cls: 'gray',   label: '미설정',   tip: '' },
                            };
                            const m = statusMap[record.claraStatus] || statusMap.unset;
                            const chip = (
                                <div class="status-chip-wrap" style="white-space: pre;">
                                    <div class={`status-chip ${m.cls}`}>{m.label}</div>
                                </div>
                            );
                            if (m.tip) {
                                return (
                                    <a-tooltip title={m.tip}>
                                        <div style="cursor: help;">{chip}</div>
                                    </a-tooltip>
                                );
                            }
                            return chip;
                        }

                        // 폴백: 서버가 claraStatus를 내려주지 않는 경우(구버전) 기존 클라이언트 추론 유지
                        const surgeryEndAt = dayjs(record.deliveryOptions.surgeryEndAt);
                        let isOverdue = false;
                        let lastDeliveryDate = null;
                        let hasFailedDelivery = false;
                        let hasWaitingDelivery = false;
                        
                        const now = dayjs();
                        
                        // 오늘 및 오늘 이전 시점에서 가장 가까운 날짜의 발송 상태 확인
                        const checkDeliveryStatus = () => {
                            if (!record.deliveryOptions?.afterDeliveryInfo?.length) return { failed: false, waiting: false };
                            
                            let hasFailedDelivery = false;
                            let hasWaitingDelivery = false;
                            
                            // 모든 그룹의 deliveryDates를 확인
                            record.deliveryOptions.afterDeliveryInfo.forEach(info => {
                                if (!info.deliveryDates?.length) return;
                                
                                info.deliveryDates.forEach(delivery => {
                                    const deliveryDate = dayjs(delivery.date);
                                    
                                    // 오늘 날짜인 경우 - 발송 대기 상태 확인
                                    if (deliveryDate.isSame(now, 'day') && delivery.status === 'book') {
                                        hasWaitingDelivery = true;
                                    }
                                    
                                    // 오늘 이전 날짜인 경우 - 발송 실패 상태 확인
                                    if (deliveryDate.isBefore(now, 'day') && delivery.status === 'book') {
                                        hasFailedDelivery = true;
                                    }
                                });
                            });
                            
                            return { failed: hasFailedDelivery, waiting: hasWaitingDelivery };
                        };

                        // afterDeliveryInfo 배열이 있는 경우 검사
                        if (record.deliveryOptions?.afterDeliveryInfo?.length > 0) {
                            // 발송 상태 확인
                            const deliveryStatus = checkDeliveryStatus();
                            hasFailedDelivery = deliveryStatus.failed;
                            hasWaitingDelivery = deliveryStatus.waiting;
                            
                            // 모든 그룹의 deliveryDates를 확인
                            const hasBookedDates = record.deliveryOptions.afterDeliveryInfo.some(info => {
                                if (!info.deliveryDates?.length) return false;
                                return info.deliveryDates.some(date => date.status === 'book');
                            });

                            // 마지막 발송일 찾기
                            lastDeliveryDate = record.deliveryOptions.afterDeliveryInfo.reduce((lastDate, info) => {
                                if (!info.deliveryDates?.length) return lastDate;
                                
                                const groupLastDate = info.deliveryDates.reduce((latest, date) => {
                                    const currentDate = dayjs(date.date);
                                    return currentDate.isAfter(latest) ? currentDate : latest;
                                }, dayjs(0));

                                return groupLastDate.isAfter(lastDate) ? groupLastDate : lastDate;
                            }, dayjs(0));

                            // 마지막 발송일이 시술 종료일보다 과거이고, 예약된 발송이 없는 경우
                            // 그리고 시술 종료일이 미래인 경우에만 추가 등록이 필요함
                            isOverdue = lastDeliveryDate.isBefore(surgeryEndAt) && 
                                       !hasBookedDates && 
                                       surgeryEndAt.isAfter(now);
                        }
                        
                        // 발송 실패가 있는 경우 (우선순위 1)
                        if (hasFailedDelivery) {
                            return (
                                <a-tooltip title="예약된 알림톡이 발송되지 않아 발송 실패로 처리되었습니다.">
                                    <div class="status-chip-wrap" style="cursor: help; white-space: pre;">
                                        <div class="status-chip red">
                                            발송 실패
                                        </div>
                                    </div>
                                </a-tooltip>
                            );
                        }
                        
                        // 발송 대기 상태인 경우 (우선순위 2)
                        if (hasWaitingDelivery) {
                            return (
                                <a-tooltip title="오늘 발송 예정인 알림톡이 있습니다. 당일 중 발송될 예정입니다.">
                                    <div class="status-chip-wrap" style="cursor: help; white-space: pre;">
                                        <div class="status-chip orange">
                                            발송 대기
                                        </div>
                                    </div>
                                </a-tooltip>
                            );
                        }
                        
                        // 정상 발송 중인 경우 (우선순위 3)
                        if (record.deliveryOptions?.afterDeliveryInfo?.length > 0) {
                            return (
                                <div class="status-chip-wrap" style="white-space: pre;">
                                    <div class="status-chip green">
                                        정상 발송
                                    </div>
                                </div>
                            );
                        }

                        // 미설정 상태 (우선순위 4)
                        return (
                            <div class="status-chip-wrap" style="white-space: pre;">
                                <div class="status-chip gray">
                                    미설정
                                </div>
                            </div>
                        );
                    }
                },
                {
                    title: '알림톡 상세',
                    dataIndex: ['deliveryOptions', 'afterDeliveryInfo'],
                    key: 'lastDeliveryDate',
                    align: 'center',
                    customRender: ({ text, record }) => {
                        return (
                            <a-button type="link" onClick={() => this.showDetailModal(record)}>
                                상세 보기
                            </a-button>
                        );
                    }
                },
            ],
            data: [],
            searchParams: {
                dateRange: null,
                sortField: null,
                sortOrder: null,
                excludeTestCompany: true,
            },
            modals: {
                detailModal: {
                    show: false,
                    record: null
                }
            },
            paginationData: {
                currentPage: 1, 
                totalPages: 0,
            },
            listSize: 0,
            rowsPerPage: 10,
        };
    },
    computed: {
        defaultDateRange() {
          return [dayjs(), dayjs()];
        },
        apiParams() {
            return {
              startDate: this.searchParams.dateRange[0].format('YYYY-MM-DD'),
              endDate: this.searchParams.dateRange[1].format('YYYY-MM-DD'),
              sortField: this.searchParams.sortField,
              sortOrder: this.searchParams.sortOrder,
              page: this.paginationData.currentPage,
              limit: this.rowsPerPage,
              excludeTestCompany: this.searchParams.excludeTestCompany,
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.initSearchParams();
            this.fetchData();
        },
        showDetailModal(record) {
            this.modals.detailModal = {
                show: true,
                record: { ...record } // 깊은 복사를 위해 스프레드 연산자 사용
            };
        },
        closeDetailModal() {
            this.modals.detailModal = {
                show: false,
                record: null
            };
        },
        goToCertificateList() {
            this.$router.push({
                path: '/certificate/history',
                query: { ...this.$route.query }
            });
        },
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.fetchData();
        },
        getNextDeliveryDate(afterDeliveryInfo, record) {
            // 1. nextDeliveryAt이 있으면 우선 사용
            if (record?.deliveryOptions?.nextDeliveryAt) {
                return dayjs(record.deliveryOptions.nextDeliveryAt).format('YYYY/MM/DD');
            }
            
            if (!afterDeliveryInfo?.length) return '-';

            // 모든 deliveryDates를 하나의 배열로 합치기
            const allDeliveryDates = afterDeliveryInfo.reduce((acc, info) => {
                if (!info.deliveryDates?.length) return acc;
                return [...acc, ...info.deliveryDates];
            }, []);

            if (!allDeliveryDates.length) return '-';

            // 'book' 상태인 날짜 찾기
            const bookDates = allDeliveryDates.filter(date => date.status === 'book');
            
            // 'book' 상태인 날짜가 없으면 '모두 발송됨' 표시
            if (bookDates.length === 0) {
                return '모두 발송됨';
            }
            
            // 'book' 상태인 날짜 중 가장 빠른 날짜 찾기
            bookDates.sort((a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf());
            return dayjs(bookDates[0].date).format('YYYY/MM/DD');
        },
        async handleTableChange(pagination, filters, sorter) {
            if (sorter.columnKey === 'nextDeliveryAt') {
                this.searchParams.sortField = 'nextDeliveryAt';
                this.searchParams.sortOrder = sorter.order;
            } else {
                this.searchParams.sortField = null;
                this.searchParams.sortOrder = null;
            }
            // sort 파라미터 제거
            delete this.searchParams.sort;
            await this.fetchData();
        },
        async handleDateChange(dates) {
            if (!dates || !dates.length) return;
            
            const [startDate, endDate] = dates;
            this.searchParams.startDate = startDate.format('YYYY-MM-DD');
            this.searchParams.endDate = endDate.format('YYYY-MM-DD');
            await this.fetchData();
        },
        async fetchData() {
            try {
                const response = await this.$apiInstance.post(
                    '/nfts/delivery/by/date',
                    this.apiParams
                );
                if(!response.data || !response.data.docs) {
                    this.data = [];
                    return;
                }
                this.data = response.data.docs;
                this.listSize = response.data.totalDocs;
                this.paginationData.totalPages = response.data.totalPages;
            } catch(error) {
                console.error(error);
            }
        },
        
        initSearchParams() {
            this.searchParams = {
                dateRange: this.defaultDateRange,
                sortField: null,
                sortOrder: null,
                excludeTestCompany: true,
            };
        },
  },
};
</script>
<style lang="scss">
    @import "@/assets/scss/certificates.scss";
</style>
